import React, { ReactNode } from 'react'
import styled from 'styled-components'
import { Borders, Colors, Fonts, FontWeights } from '../../constants'
import { MaxButton } from './MaxButton'
import { UseWethButton } from './UseWethButton'

interface Props {
  label: string
  value: string
  balance: string
  rate?: string
  symbol?: string
  disabled?: boolean
  onValueChange: (value: string) => void
  onMax: () => void
  children: ReactNode
  className?: string
}

export function InputItem({
  label,
  symbol,
  rate,
  value,
  balance,
  disabled,
  onValueChange,
  onMax,
  children,
  className,
}: Props) {
  return (
    <Content className={className}>
      <InputItemTopRow>
        <InputItemLabel>{label}</InputItemLabel>
        {rate && <Rate>{rate ?? '-'}</Rate>}
      </InputItemTopRow>
      <InputItemRow>
        <Input disabled={disabled} placeholder="0.0" value={value} onChange={(e) => onValueChange(e.target.value)} />
        <ImageContainer>{children}</ImageContainer>
      </InputItemRow>
      <InputItemBottomRow>
        <Balance>Wallet: {balance}</Balance>
        {balance && <MaxButton onClick={onMax} />}
        <UseWethButton symbol={symbol} />
      </InputItemBottomRow>
    </Content>
  )
}

const Content = styled.div`
  margin-bottom: 10px;
  padding: 0 20px;
`

const InputItemTopRow = styled.div`
  margin-bottom: 5px;
  display: flex;
  justify-content: space-between;
`

const InputItemLabel = styled.strong`
  margin: 0;
  display: block;
  font-size: 11px;
  text-transform: uppercase;
`

const Rate = styled.p`
  margin: 0;
  display: block;
  color: ${Colors.DarkerGray};
  font-size: 11px;
  text-transform: uppercase;
`

const InputItemRow = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
`

const Input = styled.input`
  margin: 0;
  padding: 10px 125px 10px 15px;
  display: block;
  flex-basis: 100%;
  width: 100%;
  font-size: 18px;
  font-family: ${Fonts.Monospace};
  font-weight: ${FontWeights.Bold};
  outline: none;
  border: 1px solid ${Borders.Color};
  border-radius: ${Borders.Radius};
  background: rgb(239, 239, 239);
  background: linear-gradient(0deg, rgba(239, 239, 239, 1) 0%, rgba(238, 238, 238, 1) 100%);

  &::placeholder {
    color: #c3c5ca;
  }

  &:focus {
    border-color: ${Colors.Hover};
  }

  &:disabled {
    color: ${Colors.Black};
  }
`

const ImageContainer = styled.div`
  position: absolute;
  top: 11px;
  right: 15px;
  display: flex;
  align-items: center;
  font-size: 15px;
  font-weight: ${FontWeights.Bold};
`

const InputItemBottomRow = styled.div`
  margin-top: 5px;
  display: flex;
  align-items: center;
`

const Balance = styled.p`
  margin: 0;
  display: block;
  color: ${Colors.DarkerGray};
  font-size: 11px;
  text-transform: uppercase;
`
